import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommunicationService } from 'src/app/services/communication.service';

@Component({
  selector: 'app-link-podium',
  templateUrl: './link-podium.component.html',
  styleUrls: ['./link-podium.component.scss']
})
export class LinkPodiumComponent {
  @Input() partner;
  @Input() currentData;
  @Input() modal;

  @Output() onConnected = new EventEmitter();

  public busy = true;
  public updating = false;

  public availableLocations: any = [];
  public selectedLocation: any = null;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private communicationService: CommunicationService,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.busy = false;
    console.log('here', this.currentData);
  }

  ngOnChanges(changes) {
    if (changes.currentData && changes.currentData.currentValue) {
      const data = changes.currentData.currentValue;
      this.availableLocations = data.locations;

      this.selectedLocation = this.availableLocations.find(
        loc => loc.locationUID === data.selectedLocation?.locationUID
      );
    }
  }

  isValid() {
    if (this.selectedLocation == null) {
      return true;
    }

    return false;
  }

  connect() {
    // Used oath2 process
  }

  update(){
    this.updating = true;
    this.communicationService.saveData(this.partner.ID,
      {
        TextPlatformSystemId: 2,
        Podium: {
          SelectedLocation: this.selectedLocation
        }
      }
    ).subscribe(res => {
      this.updating = false;
    });
  }

  done() {
    this.onConnected.emit();
  }
}
